const routes = [{
  path: '/message',
  component: () => import('@/views/message'),
  name: 'message',
  meta: {
    title: '消息管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/message.js